import $ from 'jquery';
import ClipListExtend from './clip-list';
import VideoCollection from '../libs/core/video-collection';
import VideoPlayer from '../libs/video-player';
import * as api from '../libs/api';
import converter from '../libs/converter';
import {$document, $ctx, $extendBtn, $listWrap} from './jqdom-static';
import * as logger from '../libs/logger';
import CP from '../libs/cp-meta';

// Module Instantiations
const videoCollection = new VideoCollection(converter.convert(C.VO2.data.clips));
const videoPlayer = VideoPlayer.create();
const clipList = ClipListExtend.create({expender: $extendBtn, container: $listWrap});

// Define Event Listeners
clipList.on('more', fetchAPISource)
  .on('itemClick', (e, elem) => {
    const clip = videoCollection.get({id: $(elem).data('vid'), where: 'collection'});
    const isClosingAction = clipList.indexOfHighlighted === clip.index;

    videoPlayer.close();

    if (!isClosingAction) {
      videoPlayer.open(clip);
      moveScrollPosition($(e.target));
    }

    logger.togglePlayerLog(e, isClosingAction, videoCollection.length, clip, elem);
  })
  .on('expand', logger.unfoldLog.bind(null))
  .on('fold', (e) => {
    // 펼쳐보기를 접을때 총 5개의 리스트만 노출이 되는데, 열려있는 플레이어가 해당 리스트에 속하지 않을 경우 닫는다.
    if (clipList.indexOfHighlighted >= clipList.viewCount) {
      videoPlayer.close();
    }
    logger.foldLog(e);
  });

videoPlayer.on('open', renderPlayer)
  .on('switch', (e) => {
    const {clipData, nowPlaying} = e.detail;
    logger.playlistLog({
      clip: $.extend({}, clipData, {index: clipList.indexOfHighlighted || 0}),
      rc: clipList.length,
      evt: e
    });
    logger.sendS2Log(clipData, nowPlaying);
  })
  .on('destroy', clipList.highlight.bind(clipList, -1));

logger.staticLogs($ctx, {
  definitions: {
    '3': {at: 'link', p: 3},
    '11': {at: 'link', p: 11},
    '18': {at: 'link', p: 18},
    '21': {at: 'link', p: 21},
    '28': {at: 'link', p: 28},
    '31': {at: 'link', p: 31},
    '34': {
      at: 'link',
      p: 34,
      extParamSetter(clip) {
        switch (true) {
          case clip.isOrgDoc:
          case clip.isKakaoTVPlaylist:
            return {
              cpId: clip.cp,
              channelId: clip.bifChannelId,
              isSMR: clip.isSMR,
              isLive: false
            };
          case clip.cp === CP.codes.KAKAOTV_NO_LIVE:
            return {
              cpId: CP.codes.KAKAOTV_NO_LIVE,
              channelId: '',
              isSMR: '',
              isLive: false
            };
          case clip.cp === CP.codes.YOUTUBE:
            return {
              cpId: CP.codes.YOUTUBE,
              channelId: CP.codes.YOUTUBE_CHANNEL_ID,
              isSMR: false,
              isLive: false
            };
          default:
            return {
              cpId: clip.cp,
              channelId: clip.bifChannelId,
              isSMR: clip.isSMR,
              isLive: false
            };
        }
      }
    }
  },
  getResultCount() {
    return clipList.length;
  },
  nowPlaying() {
    return videoPlayer.nowPlaying();
  },
  getClipByIndex(idx) {
    return videoCollection.getByIndex(idx);
  }
});

// Define Callbacks
function renderPlayer(clip) {
  clipList.insertTo(clip.index, videoPlayer.$player).highlight(clip.index);
  renderPlayList(clip);
}

function fetchAPISource(renderToClipList) {
  api.fetchClips().done(res => {
    clipList.isEnd = res.isEnd;
    const data = converter.convert(res.data);
    videoCollection.push(data);
    renderToClipList(data);
  });
}

function renderPlayList(clip) {
  const relatedClips = videoCollection.get({id: clip.videoId, where: 'playlist'});
  const toTemplateData = converter.mapClipToPlaylistTemplateData.bind(null, clip);

  if (relatedClips) {
    videoPlayer.renderPlayList(toTemplateData(relatedClips));
    return;
  }

  api.fetchRelatedClips(clip)
    .then((res) => {
      if ($.isEmptyObject(res)) {
        videoPlayer.closeFooter();
      } else {
        const data = converter.playlistToClipFormat(clip, res);

        videoCollection.assign(clip.videoId, data);
        videoPlayer.renderPlayList(toTemplateData(data));
      }
    })
    .fail(err => {
      console.error(err);
      videoPlayer.closeFooter();
    });
}

function moveScrollPosition($target) {
  const marginTop = 19;
  const scrollTop = $target.offset().top;
  $document.stop().animate({scrollTop: scrollTop - marginTop}, 300);
}



/** WEBPACK FOOTER **
 ** ./src/VO2/tot/index.js
 **/